import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, Platform } from 'ionic-angular';
import { ConfigService } from '../../providers/config';
import { SearchService } from '../../providers/search';
import { ErrorHandling } from '../../shared/error.handling';
import { TranslateCategoryPipe } from '../../shared/translate-category.pipe';
import { FileResultListPage } from '../file-result-list/file-result-list';
import { SearchresultsPage } from '../searchresults/searchresults';
import { MoreDetails } from './more-details';
import { UserService } from '../../providers/user';

@Component({
    selector: 'page-detail',
    templateUrl: 'detail.html'
})

export class DetailPage {

    id: any;
    category: string;
    objDatasets: any;
    resultTotalCount: any;
    filesCount: number;
    fileUrl: any;
    config: any = {};

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public searchService: SearchService,
                public alertCtrl: AlertController,
                public loadingCtrl: LoadingController,
                public userService: UserService,
                public platform: Platform,
                public errorHandling: ErrorHandling,
                public configService: ConfigService) {

        this.id = navParams.get('objId');
        this.category = navParams.get('orgaStruct');
    }

    /** Loads result from server */
    ionViewDidLoad() {
        let loader = this.loadingCtrl.create();
        loader.present();
        this.config = this.configService.getConfig();

        this.searchService.getItemById(this.id, this.category)
            .subscribe(
                (data) => {
                    loader.dismiss();
                    this.objDatasets = data.objDatasets;
                },
                (error) => {
                    loader.dismiss();
                    this.errorHandling.handle(error, 'Detail - getItemById');
                }
            );

        this.getFileCount(this.id, this.category);
    }

    /**
     * Retries the number of appended files and concats the file url
     * @param {string} ObjId
     * @param {string} orgaStruct
     */
    getFileCount(ObjId: string, orgaStruct: string) {
        let storedtoken = localStorage.getItem('nodetoken');
        let storedendpoint = JSON.parse(localStorage.getItem('appconfig'));

        ObjId = ObjId.replace(':', '-');

        this.fileUrl = storedendpoint.apiendpoint + 'organizations/' + orgaStruct + '/objects/' + ObjId + '/files' + '?X-NODE-TOKEN=' + storedtoken + '';

        this.searchService.fileInfos(ObjId, orgaStruct)
            .subscribe((fileInfos) => {
                this.filesCount = Object.keys(fileInfos).length; //File count
            }, (error) => {
                this.errorHandling.handle(error, 'Detail - getFileInfos');
            });
    }

    /**
     * Retrieves hierarchy structure from server
     * @param {string} searchTerm
     * @param {string} category
     * @param {string} hierachieField
     * @param noHierarchy
     */
    getHierarchyStructure(searchTerm: string, category: string, hierachieField: string, noHierarchy?: boolean) {
        let filter: boolean = false;
        let loader = this.loadingCtrl.create();
        loader.present();
        let trimSearchTerm;

        if (noHierarchy) {
            let tempSearchTerm = searchTerm.split(';');
            trimSearchTerm = this.userService.trimArray(tempSearchTerm).join(';');
            searchTerm = trimSearchTerm;
        }

        this.searchService.searchHierarchy(searchTerm, category, hierachieField, '', noHierarchy)
            .subscribe(
                (success) => {
                    let searchResults = success.results;
                    if (searchResults) {
                        this.navCtrl.push(SearchresultsPage, {
                            'resultList': searchResults,
                            'resultTotalCount': success.resultTotalCount,
                            'category': category,
                            'searchTerm': searchTerm,
                            'searchFilter': filter,
                            'hierachieField': hierachieField,
                            'searchType': 1
                        });
                    } else {
                        this.presentAlert(category);
                    }
                    loader.dismiss();
                },
                (error => {
                    this.errorHandling.handle(error, 'Detail - getHierarchyStructure');
                    loader.dismiss();
                })
            );
    }

    /**
     * Presents alert, that no item was found for the search term
     * @param {string} cat
     */
    presentAlert(cat: string) {
        let translateCategoryPipe = new TranslateCategoryPipe();
        let searchCategoryString = translateCategoryPipe.transform(cat);

        let alert = this.alertCtrl.create({
            title: 'Suche ' + searchCategoryString,
            subTitle: 'Keine ' + searchCategoryString + ' gefunden!',
            buttons: ['Ok']
        });
        alert.present();
    }

    /**
     * Adds favorite to localStorage
     * @param {Number} ObjId
     * @param {Object} orgaStruct
     * @param {Object} objDatasets
     */
    addFavorite(ObjId: number, orgaStruct: string, objDatasets: object) {
        let isFavorite = this.checkFavorite(ObjId);
        let storedFavorites: any = JSON.parse(localStorage.getItem('favorites'));
        let tempFavorite = {
            'ObjId': ObjId,
            'orgaStruct': orgaStruct,
            'objDatasets': objDatasets
        };

        if (!isFavorite) {
            storedFavorites.push(tempFavorite);
            localStorage.setItem('favorites', JSON.stringify(storedFavorites));
        } else {
            let BreakException = {};
            try {
                Object.keys(storedFavorites).forEach((key) => {
                    if (storedFavorites[key]['ObjId'] == ObjId) {
                        storedFavorites.splice(key, 1);
                        throw BreakException;
                    }
                });
            } catch (ex) {
                if (ex !== BreakException) {
                    console.error(ex);
                }
            }
            localStorage.setItem('favorites', JSON.stringify(storedFavorites));
        }
    }

    /**
     * Checks if object is already saved as favorite in localStorage
     * @param {Number} ObjId
     * @returns {boolean}
     */
    checkFavorite(ObjId: Number): boolean {
        let storedFavorites = JSON.parse(localStorage.getItem('favorites'));
        let isStored: boolean = false;

        for (let prop in storedFavorites) {
            if (storedFavorites.hasOwnProperty(prop)) {

                if (storedFavorites[prop]['ObjId'] == ObjId) {
                    isStored = true;
                }
            }
        }
        return isStored;
    }

    /**
     * Retrieves file info from appended file
     * @param {string} ObjId
     * @param {string} orgaStruct
     */
    getFileInfos(ObjId: string, orgaStruct: string) {
        this.searchService.fileInfos(ObjId, orgaStruct)
            .subscribe((fileInfos) => {
                let size = Object.keys(fileInfos).length; //File count

                if (size == 1) { //Only one file
                    this.searchService.getFile(ObjId, fileInfos, orgaStruct);
                } else if (size > 1) { //More than one file
                    //Open file list
                    this.navCtrl.push(FileResultListPage, {
                        fileInfos: fileInfos,
                        filesCount: this.filesCount,
                        objId: ObjId,
                        orgaStruct: this.category
                    });
                }
            }, (error) => {
                this.errorHandling.handle(error, 'Detail - getFileInfos');
            });
    }

    /**
     * Opens url in browser
     * @param {string} url
     */
    openInBrowser(url: string) {
        let prefix = 'http://';
        if (url.indexOf(prefix) != 0) {
            url = prefix + url;
        }
        window.open(url, '_blank');
    }

    /**
     * Opens more detail page
     * @param {Object} item
     * @param {string} cat
     */
    moreDetails(item: object, cat: string) {
        this.navCtrl.push(MoreDetails, {details: item, category: cat});
    }

    /**
     * Opens given location on map
     * @param {string} place
     * @param {string} postcode
     * @param {string} street
     */
    openLocationInMap(place: string, postcode: string, street: string) {
        window.open('https://maps.google.com/?q=' + place + '+' + postcode + '+' + street, '_blank');
    }
}



// WEBPACK FOOTER //
// ./src/pages/detail/detail.ts